import React from "react";
import "./Fooditem.css";
import { useDispatch, useSelector } from "react-redux";
import { action } from "../../store/CartCounter";
function Fooditem({ food_item }) {
  const cartItems=useSelector((state)=>{return state});
  const dispatcher=useDispatch();
  return (
    <div className="col-3">
      <figure className="figure">
        <img className="food_img" src={food_item.image} alt={food_item.name} />
        <figcaption className="p-3">
          <div className="d-flex justify-content-between py-2">
            <h4 className="food-name">{food_item.name}</h4>
            <div>
              <span>
                <i className="fa-solid fa-star"></i>
              </span>
              <span>
                <i className="fa-solid fa-star"></i>
              </span>
              <span>
                <i className="fa-solid fa-star"></i>
              </span>
              <span>
                <i className="fa-solid fa-star"></i>
              </span>
              <span>
                <i className="fa-regular fa-star"></i>
              </span>
            </div>
          </div>
          <p className="food-description">{food_item.description}</p>
          <div className="d-flex justify-content-between">
            <span className="price">${food_item.price}</span>
            {!cartItems[food_item._id] ? (
              <button onClick={()=>dispatcher(action.addToCart(food_item._id))} className="add-btn">Add</button>
            ) : (
              <div className="counter">
                <button onClick={()=>dispatcher(action.removeFromCart(food_item._id))}>-</button>
                <span>{cartItems[food_item._id]}</span>
                <button onClick={()=>dispatcher(action.addToCart(food_item._id))}>+</button>
              </div>
            )}
          </div>
        </figcaption>
      </figure>
    </div>
  );
}

export default Fooditem;
